import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import useStore from "store/store";
import { isAuthenticated } from "utils/auth";

const PrivateRoute = () => {
  const { isAuth, setIsAuth } = useStore((state) => state);

  useEffect(() => {
    const checkAuth = async () => {
      const status = await isAuthenticated();
      setIsAuth(status.authorized);
    };
    checkAuth();
  }, [setIsAuth]);

  if (isAuth === null) {
    return <div>Loading...</div>;
  }

  return isAuth ? <Outlet /> : <Navigate to="/auth" replace />;
};

export default PrivateRoute;
